import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-calendar',
  template: `
    <p-calendar
      [(ngModel)]="value"
      [showIcon]="showIcon"
      [showButtonBar]="showButtonBar"
      [placeholder]="placeholder"
      [disabled]="readonlyInput"
      [maxDate]="maxDate"
      (onSelect)="onDateSelect($event)"
    ></p-calendar>
  `,
})
export class CustomCalendarComponent {
  @Input() value: Date | null = null;
  @Input() showIcon: boolean = true;
  @Input() showButtonBar: boolean = true;
  @Input() placeholder: string = 'mm/dd/yyyy';
  @Input() readonlyInput: boolean = true;
  @Input() maxDate: Date | null = null;

  @Output() valueChange: EventEmitter<Date> = new EventEmitter<Date>();

  onDateSelect(event: Date): void {
    this.valueChange.emit(event);
  }
}
